import React, {
    useState,
    useEffect
} from 'react'
import Image from "./Figure.png"

import JSONDATA from './genes.json';
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
export default function ScRNA() {
    const [body, setBody] = React.useState(null);
    const [headers, setHeaders] = React.useState(null);
    const [loading, setLoading] = useState(true);
    const handleGeneData = (data) => {
        let listItems = data.header.map((head, index) =>
            <th key={index}>{head}</th>
        )
        let bodyItems = data.data.map((rowContent, rowId) =>
            <tr key={rowId}>{rowContent.map((col, colId) =>
                <td key={colId} >{col}</td>
            )}
            </tr>
        )
        setHeaders(listItems)
        setBody(bodyItems)
    }
    const fetchGene = (name) => {
        {
            JSONDATA.filter((val) => {
                if (val.name.toLowerCase() === name.toLowerCase()) {
                    fetch("https://s3.us-east-2.amazonaws.com/ksusztak.genemap/EH/" + val.uuid + ".json")
                        .then(response => response.json())
                        .then(data => handleGeneData(data))
                } else {
                    setHeaders(null)
                }
            })
        }
    }
    return (
        <div>
            <div>

            <div>
                            <div>
                <img
                    src={Image}
                    alt="umap"
                />
            </div>

	    <div>
	     <span class="query">Please enter a gene name </span>
                <input type="text" placeholder="search..."
                    onChange={
                        e => fetchGene(e.target.value)
                    }
                />
                {headers && body ? (
                    <table style={{ width: 500 }}>
                        <thead><tr>{headers}</tr></thead>
                        <tbody>{body}</tbody>
                    </table>

                ) : (
                    <div>
                    </div>
                )}
            </div>
	    </div>
     <br></br>
            </div>
            <div className="bottom-component">
            </div>
        </div>
    );
}
